import BillingModel from "../../../../../types/billing-model";
import BillingStatus from "../../../../../types/billing-status";

export type BillingsOrderCargoTaxiRecalculateContractCargoCompany = {
  companyName: string;
  displayName: string;
};

export type BillingsOrderCargoTaxiRecalculateContract = {
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  discountLimit: number;
  cargoCompany: BillingsOrderCargoTaxiRecalculateContractCargoCompany;
  model: BillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
};

export type BillingsOrderCargoTaxiRecalculateBillingNode = {
  uuid: string;
  nodeUuid: string;
  checkoutEventUuid?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinates: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export type BillingsOrderCargoTaxiRecalculateCargoOrder = {
  uuid: string;
  humanId: number;
};

export enum BillingsOrderCargoTaxiRecalculateBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiRecalculateBillingContributionBaseAmount = {
  type: BillingsOrderCargoTaxiRecalculateBillingContributionType.BASE_AMOUNT;
  comment?: string;
  distance: number;
  rate: number;
};

export type BillingsOrderCargoTaxiRecalculateBillingContributionChargeHaltings =
  {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.CHARGE_HALTING;
    comment?: string;
    distance: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateBillingContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateBillingContributionDiscountBeingLate =
  {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOther =
  {
    type: BillingsOrderCargoTaxiRecalculateBillingContributionType.DISCOUNT_OTHER;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiRecalculateBillingContribution =
  | BillingsOrderCargoTaxiRecalculateBillingContributionBaseAmount
  | BillingsOrderCargoTaxiRecalculateBillingContributionChargeHaltings
  | BillingsOrderCargoTaxiRecalculateBillingContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOptimization
  | BillingsOrderCargoTaxiRecalculateBillingContributionDiscountBeingLate
  | BillingsOrderCargoTaxiRecalculateBillingContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiRecalculateBillingContributionDiscountOther;

type BillingsOrderCargoTaxiRecalculate = {
  status: BillingStatus;
  passengers: string[];
  contract: BillingsOrderCargoTaxiRecalculateContract;
  baseAmountValue: number;
  amountForChargeHighways: number;
  amountForChargeHaltings: number;
  contractCorrectionPercentage: number;
  sumOfDiscounts: number;
  amountForDistance: number;
  allContributionsAmount: number;
  distance: number;
  date: Date;
  billingNodes: BillingsOrderCargoTaxiRecalculateBillingNode[];
  cargoOrder: BillingsOrderCargoTaxiRecalculateCargoOrder;
  planEntryUuid: string;
  billingContributions: BillingsOrderCargoTaxiRecalculateBillingContribution[];
};

export default BillingsOrderCargoTaxiRecalculate;
